<template>
    <b-form-group :label="label" :invalid-feedback="error" :state="state" class="form-search-multiselect">
        <form-input-group>
            <search-multiselect
                v-on="listeners"
                v-bind="attrs"
                :state="state"
                :value="value"
                @input="input"
                :class="['rounded-right', floatingLabel ? 'search-multiselect-floating-label' : '']"
            />
            <label
                :style="[noGutters ? { 'padding-left': '10px !important' } : { left: '2.7rem' }]"
                :if="floatingLabel"
                >{{ floatingLabel }}</label
            >
        </form-input-group>
    </b-form-group>
</template>

<script>
    import SearchMultiselect from '../search-multiselect/search-multiselect.vue';
    import FormInputGroup from '../form-input-group/form-input-group.vue';

    export default {
        name: 'FormSearchMultiselect',
        components: {
            SearchMultiselect,
            FormInputGroup,
        },
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            error: {
                type: String,
                default: null,
            },
            label: {
                type: String,
                default: null,
            },
            floatingLabel: {
                type: String,
                default: null,
            },
            noGutters: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            state() {
                if (this.error) {
                    return !this.error;
                }
            },
            attrs() {
                const { state, ...attrs } = this.$attrs;
                return attrs;
            },
            listeners() {
                const { input, ...listeners } = this.$listeners;
                return listeners;
            },
        },
        methods: {
            input(value) {
                this.$emit('input', value);
            },
        },
    };
</script>

<style lang="scss">
    @import '../../../variables.scss';
    .form-search-multiselect {
        .search-multiselect-floating-label {
            & + label {
                position: absolute;
                user-select: none;
                pointer-events: none;
                margin: 0;
                top: 0.2rem;
                left: 0.2rem;
                z-index: 99;
                font-size: 0.8rem;
                line-height: 1.1;
                color: $floating-label-color-active;
                font-weight: $floating-label-font-weight;
            }
            & > label.form-control {
                line-height: 1.6;
                padding-bottom: 0.1rem;
                padding-top: 1rem;
                z-index: inherit;
                height: $floating-label-input-height-active !important;
            }
        }
    }

    @-moz-document url-prefix() {
        .search-multiselect-floating-label {
            & + label {
                padding-left: 0.35rem !important;
            }
        }
    }
</style>
